import { useContext } from "react";
import { TranslationContext } from "../../../context/TranslationContext";
import { TranslationContextInterface } from "../../../entities/Language";
import { getValueForKey } from "../../../context/translationsUtils";
import { toFixedNumber } from "../../../utils/toFixedNumber";
import { useSelector } from "react-redux";
import {
  getCalculatedPrices,
  getCurrencyShortName,
} from "../../Calculation/slice/selectors";
import { getDataFromMixture } from "../../Mixture/selectors";
import { CheckoutListStyled } from "./CheckoutListStyled";
import { getTenantCredentials } from "../../Tenant/selectors";
import { formatCurrency } from "../../../utils/formatCurrency";

const CheckoutList: React.FC = () => {
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);
  const credentials = useSelector(getTenantCredentials);
  const currencyShortName = useSelector(getCurrencyShortName);
  const { selectedWeight, jars } = useSelector(getDataFromMixture);
  const {
    totalValueWithAllProperties,
    priceWithVatPerCup,
    discountValue,
    priceWithVatAndDiscount,
  } = useSelector(getCalculatedPrices);

  return (
    <CheckoutListStyled>
      <ul>
        <li>
          <span>
            {getValueForKey(translations, "edit_mix.sidebar_weight_hint")}
          </span>
          <span>
            {formatCurrency({
              amount: selectedWeight,
              country: credentials?.country,
              amountLabel: getValueForKey(
                translations,
                "edit_mix.sidebar_grams_hint",
              ),
            })}
          </span>
        </li>
        <li>
          <span>{getValueForKey(translations, "edit_mix.price_vat")}</span>
          <span>
            {formatCurrency({
              amount: toFixedNumber(priceWithVatPerCup, 2),
              country: credentials?.country,
              amountLabel: currencyShortName,
            })}
          </span>
        </li>
        {discountValue ? (
          <>
            <li>
              <span>{getValueForKey(translations, "edit_mix.discount")}</span>
              <span>
                {`- ${formatCurrency({
                  amount: toFixedNumber(discountValue, 2),
                  country: credentials?.country,
                  amountLabel: currencyShortName,
                })}`}
              </span>
            </li>
            <li>
              <span>
                {getValueForKey(translations, "edit_mix.price_vat_discount")}
              </span>
              <span>
                {formatCurrency({
                  amount: toFixedNumber(priceWithVatAndDiscount, 2),
                  country: credentials?.country,
                  amountLabel: currencyShortName,
                })}
              </span>
            </li>
          </>
        ) : (
          <></>
        )}
        <li>
          <span>{getValueForKey(translations, "edit_mix.number_of_pcs")}</span>
          <span>{jars}</span>
        </li>
        <li>
          <span>
            {getValueForKey(translations, "edit_mix.sidebar_total_price")}
          </span>
          <span>
            {formatCurrency({
              amount: toFixedNumber(totalValueWithAllProperties, 2),
              country: credentials?.country,
              amountLabel: currencyShortName,
            })}
          </span>
        </li>
      </ul>
    </CheckoutListStyled>
  );
};

export default CheckoutList;
